export enum InputNames {
  Page = 'page',
  Panel = 'panel',
  Question = 'question',
  Form = 'form',
}
